import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Line } from 'vue-chartjs';
import { Component, Prop } from 'vue-property-decorator';
let LineChart = class LineChart extends mixins(Line) {
    /**
     * Chartjs options
     * @see https://www.chartjs.org/docs/latest/general/
     * Note:
     * specific height - set maintainAspectRatio to false
     * set height via styles in component declaration template
     */
    get options() {
        return {
            maintainAspectRatio: false,
            responsive: true,
            layout: {
                padding: 10,
            },
            elements: {
                line: {
                    tension: 0,
                },
            },
            legend: {
                display: false,
            },
        };
    }
    get dataSetOptions() {
        return {
            label: this.label,
            backgroundColor: this.elementBackgroundColor,
            borderWidth: 6,
        };
    }
    mounted() {
        const dataset = {
            labels: this.labels,
            datasets: [
                {
                    ...this.dataSetOptions,
                    data: this.data,
                },
            ],
        };
        this.renderChart(dataset, this.options);
    }
};
__decorate([
    Prop({ type: String, default: 'rgba(0, 164, 184, 0.6)' })
], LineChart.prototype, "elementBackgroundColor", void 0);
__decorate([
    Prop({ type: String, default: '' })
], LineChart.prototype, "label", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], LineChart.prototype, "labels", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], LineChart.prototype, "data", void 0);
LineChart = __decorate([
    Component
], LineChart);
export default LineChart;
